import { render, staticRenderFns } from "./ClienCardSection.vue?vue&type=template&id=749c0e58&scoped=true&"
import script from "./ClienCardSection.vue?vue&type=script&lang=ts&"
export * from "./ClienCardSection.vue?vue&type=script&lang=ts&"
import style0 from "./ClienCardSection.vue?vue&type=style&index=0&id=749c0e58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749c0e58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
